import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { BarChart } from '@mui/x-charts/BarChart';
import { useTheme } from '@mui/material/styles';
import { Skeleton } from '@mui/material';

export default function PageViewsBarChart({ chartData, loading }) {
  const theme = useTheme();
  const colorPalette = [
    (theme.vars || theme).palette.primary.dark,
    (theme.vars || theme).palette.primary.main,
    (theme.vars || theme).palette.primary.light,
  ];


  return (
    <Card variant="outlined" sx={{ width: '100%' }}>
      <CardContent>
        <Typography component="h2" variant="subtitle1" gutterBottom>
          Top Manufacturers
        </Typography>
        <Stack sx={{ justifyContent: 'space-between' }}>
          <Stack
            direction="row"
            sx={{
              alignContent: { xs: 'center', sm: 'flex-start' },
              alignItems: 'center',
              gap: 1,
            }}
          >


          </Stack>
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            Leading EV Manufacturers & Market Share
          </Typography>
        </Stack>
        {chartData && chartData.length > 0 ? (
          <BarChart
            borderRadius={8}
            colors={colorPalette}
            xAxis={[
              {
                scaleType: 'band',
                categoryGapRatio: 0.5,
                data: chartData.map(d => d.manufacturer),
              },
            ]}
            series={[
              {
                label: 'Count',
                data: chartData.map(d => d.count),
              },
            ]}
            height={300}
            margin={{ left: 50, right: 0, top: 20, bottom: 20 }}
            grid={{ horizontal: true }}
            slotProps={{
              legend: {
                hidden: true,
              },
            }}
          />
        ) : (
          <Skeleton
            variant="rectangular"
            height={300}
            animation="wave"
            sx={{
              borderRadius: 1
              , bgcolor: theme.palette.background.paper
            }}
          />
        )}
      </CardContent>
    </Card>
  );
}
